import { request } from './request'

/**
 * 积分兑换相关接口
 */
export const scoreshopApi = {
  /** 积分礼品列表 */
  getScoreGoodsList(data) {
    return request('/api/scoreshop/scoregoodslist', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 现金券列表 */
  getCouponList(data) {
    return request('/api/scoreshop/couponlist', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 免运费券列表 */
  getFreeList(data) {
    return request('/api/scoreshop/freelist', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 积分兑换商品订单列表 */
  getScoreOrderList(data) {
    return request('/api/scoreshop/scoreorderlist', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 积分兑换商品 */
  exchangeGoods(data) {
    return request('/api/scoreshop/exchangegoods', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 积分兑换优惠券/免运费券 */
  exchangeCoupon(data) {
    return request('/api/scoreshop/exchangecoupon', {
      method: 'POST',
      formData: true,
      body: data
    })
  }
}
